import ImageCompare from 'image-compare-viewer';

const viewers = [...document.querySelectorAll('.image-compare-viewer')];

const defaults = {
    addCircle: true,
    showLabels: true,
    hoverStart: true,
};

viewers.forEach((element) => {
    const options = Object.assign(defaults, JSON.parse(element.dataset.options));
    new ImageCompare(element, options).mount();
});
